import {isString} from 'lodash';
import React, {Children} from 'react';
import styled from 'styled-components';

import {buildMarkdownDecoratedSkipCountingTextContentComponent} from '../../../../../srcCommon/formatters/markdown/markdownDecoratedComponents';
import {NodeTransform} from '../../../../../srcCommon/formatters/markdown/markdownFormatterTypes';
import {transformEmojis} from '../../../../helpers/emoji/emojiAndEmoticonsTextHelpers';
import {EmojiMap} from '../../../../services/emojis/emojis';

/*
 * Style.
 */

const StyledDecoratedEmojiImg = buildMarkdownDecoratedSkipCountingTextContentComponent(styled.img`
  height: 1.4em;
  width: 1.4em;
  margin-bottom: -0.07em;
  vertical-align: text-bottom;
  object-fit: contain;
`);

/*
 * Transform.
 */

export function makeMarkdownTransformEmojis(emojiValidationMap: EmojiMap): NodeTransform {
  return (node, previousToken) =>
    Children.map(node, (child) => {
      // We only transform strings.
      if (!isString(child)) {
        return child;
      }

      // Replace the emojis by a custom component.
      return transformEmojis(
        child,
        emojiValidationMap,
        (key, emojiUrl, shortcode) => <StyledDecoratedEmojiImg key={key} alt={shortcode} src={emojiUrl} />,
        previousToken,
      );
    });
}
